import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'

Vue.use(Vuex)

const apiBaseURL = process.env.VUE_APP_API_URL

const state = () => ({
  commentToEdit: {},
  reviewInfo: {}
})

const getters = {
  reviewInfo: state => {
    return state.reviewInfo
  }
}

const mutations = {
  cr_setEditComment (state, comment) {
    state.commentToEdit = comment
  },
  cr_updateReviewInfo (state, reviewInfo) {
    state.reviewInfo = reviewInfo
  },
  cr_updateComments (state, comments) {
    state.reviewInfo.comments = comments
  }
}

const actions = {
  async cr_callAPI ({ state }, config) {
    try {
      const result = await axios({
        url: `${apiBaseURL}${config.url}`,
        method: config.method || 'get',
        data: config.data,
        headers: {
          Authorization: `Bearer ${state.reviewInfo.user_token || config.token}`
        }
      })
      return result.data
    } catch (err) {
      throw new Error(err.message)
    }
  },
  async cr_createReview (_, payload) {
    try {
      const result = await axios({
        url: `${apiBaseURL}/r/reviews`,
        method: 'POST',
        data: payload,
        headers: {
          Authorization: `Bearer ${payload.userToken}`
        }
      })
      return result
    } catch (err) {
      throw new Error(err.message)
    }
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
